import { useNavigate } from 'react-router-dom';
import { NonOrderableProductProps } from '../interface/interface';
import LoadingButton from './LoadingButton';
import ShopAllMedications from './ShopAllMedications';

export function NonOrderableProducts(props: NonOrderableProductProps) {
  const navigate = useNavigate();

  if (!props.data.length) return <></>;

  return props?.data?.map((product) => (
    <li
      className="group relative flex flex-col rounded-xl border md:border-secondary-cornflowerblue-500
      bg-white text-left cursor-pointer h-full overflow-hidden
      transition-all duration-200 ease-out origin-center"
      key={product.id}
    >
      <button
        type="button"
        className="flex flex-1 flex-col px-4 pt-5 pb-0"
        onClick={() =>
          navigate(`/product/patient/${product?.product_code}`, {
            state: {
              from: window.location.pathname,
              nonOrderable: true,
            },
          })
        }
      >
        {/* Product image */}
        <div className="w-full flex items-center justify-center relative">
          <img
            className="w-full h-40 object-contain"
            src={product.image_url}
            alt="product-image"
            style={{ objectFit: 'contain' }}
            id={`product-image-${product?.product_code}`}
          />
          <div className="w-full h-full flex z-10 absolute top-0 left-0 justify-center items-center bg-white opacity-50" />
          <div className="w-full h-full flex z-20 absolute top-0 left-0 justify-center items-center bg-transparent">
            <span className="text-black text-sm w-6/7 font-semibold text-center select-text italic">
              Please contact our team on 1800 123 687 to arrange access
            </span>
          </div>
        </div>

        {/* Brand + product name */}
        <div className="flex flex-col text-left gap-1 mt-3">
          <p className="text-xs font-semibold uppercase tracking-wide text-secondary-cornflowerblue-600">
            {product.product_brand}
          </p>
          <div className="flex justify-between">
            <p className="text-xs md:text-sm font-regular text-primary-blue-500 md:two-line-ellipsis relative leading-normal line-clamp-2 min-h-9">
              {product.name}
            </p>
            <p className="text-xs text-grey-500 font-regular block md:hidden ml-2">
              {product.weight}
              {product.unit}
            </p>
          </div>
        </div>

        <div className="flex md:justify-between justify-end items-center mt-6 mb-3">
          <p className="text-xs text-grey-500 font-regular hidden md:block">
            {product.weight}
            {product.unit}
          </p>
          <span className="text-lg sm:text-md font-semibold text-primary-blue-500">
            ${product.price}
          </span>
        </div>
      </button>

      <LoadingButton
        buttonText="Add to Cart"
        isLoading={false}
        buttonIcon={<>{'🛒'}</>}
        isDisabled={true}
        className="!rounded-none !py-4 text-xs md:text-sm"
      />

      {props.enableShopAllMedications ? (
        <div className="bg-primary-blue-500 rounded-lg hidden lg:flex items-center justify-center">
          <ShopAllMedications className="flex flex-col items-center text-xl text-white font-semibold w-full h-full justify-center text-center" />
        </div>
      ) : null}
    </li>
  ));
}
